import React from 'react'
import PropTypes from 'prop-types'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import { useResponsiveBreakpointsVersion } from 'contexts/ResponsiveBreakpointsContext'
import ResponsiveBreakpointsRolloutBoundary from './ResponsiveBreakpointsRolloutBoundary'

const DISPLAY_CONTENTS_STYLE = Object.freeze({ display: 'contents' })

const GlobalOverlaysVersionMarker = ({ children }) => {
  const version = useResponsiveBreakpointsVersion()

  return (
    <div
      data-responsive-breakpoints={version}
      data-responsive-breakpoints-page={
        RESPONSIVE_BREAKPOINT_PAGES.GLOBAL_OVERLAYS
      }
      style={DISPLAY_CONTENTS_STYLE}>
      {children}
    </div>
  )
}

GlobalOverlaysVersionMarker.propTypes = {
  children: PropTypes.node.isRequired
}

const GlobalOverlaysWithRollout = ({ children }) => (
  <ResponsiveBreakpointsRolloutBoundary
    fallback={null}
    page={RESPONSIVE_BREAKPOINT_PAGES.GLOBAL_OVERLAYS}>
    <GlobalOverlaysVersionMarker>{children}</GlobalOverlaysVersionMarker>
  </ResponsiveBreakpointsRolloutBoundary>
)

GlobalOverlaysWithRollout.propTypes = {
  children: PropTypes.node.isRequired
}

export default GlobalOverlaysWithRollout
